import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import axios from "axios";

import Game from "./pages/Game";
import LeaderBoard from "./pages/LeaderBoard";
import GameRecord from "./pages/GameRecord";
import checkAuthState from "./utils/check-auth-state";
import { setUser } from "./store/slices/authSlice";
import { useDispatch } from "react-redux";

const App = () => {
  const dispatch = useDispatch();

  // axios.defaults.baseURL = "http://localhost:5000/api";
  axios.defaults.baseURL = "https://glacial-wildwood-13132.herokuapp.com/api";

  useEffect(() => {
    dispatch(setUser(checkAuthState()));
  }, [dispatch]);

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Game />} />
          <Route path="/leaderboard" element={<LeaderBoard />} />
          <Route path="/:id" element={<GameRecord />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
